import constant from "../../constant";
import axios from "axios";
import router from "../../router";
const api = constant.api + "sellers";
// initial state
const state = () => ({
  all: [],
  sellers: [],
  seller: {},
});

// getters
const getters = {
  getAll: (state) => {
    return state.all;
  },
  getSeller: (state) => {
    return state.seller;
  },

  getSellers: (state) => {
    return state.sellers;
  },
};

// actions
const actions = {
  async getAll({ commit }) {
    await axios.get(api).then((response) => {
      let sellers = response.data;
      commit("setSellers", sellers);
    });
  },
  async show({ commit }, reference) {
    await axios.get(api + "/" + reference).then((response) => {
      let seller = response.data;
      commit("setSeller", seller);
    });
  },

  async destroy({ commit, dispatch }, reference) {
    await axios.delete(api + "/" + reference).then((response) => {
      let message = response.data.message;
      let status = response.data.status;
      dispatch("notification/store", { status, message }, { root: true });
      if (status == "success") {
        let sellers = response.data.data;
        commit("setSellers", sellers);
      }
    });
  },

  async store({ commit, dispatch }, data) {
    await axios.post(api, data).then((response) => {
      let message = response.data.message;
      let status = response.data.status;
      dispatch("notification/store", { status, message }, { root: true });
      if (status == "success") {
        router.push({
          name: "sellers-index",
        });
      }
    });
  },

  async update({ dispatch }, data) {
    await axios.put(api + "/" + data.reference, data).then((response) => {
      let message = response.data.message;
      let status = response.data.status;

      if (status == "success") {
        dispatch("notification/store", { status, message }, { root: true });
        router.push({
          name: "sellers-index",
        });
      }
    });
  },
};

// mutations
const mutations = {
  setSellers(state, sellers) {
    state.all = sellers;
    state.sellers = sellers;
  },
  setSeller(state, seller) {
    state.seller = seller;
  },
  
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

